import { render } from "../templates/ExportQuestionsForm.html?vue&type=template&id=f897d894"
import script from "./ExportQuestionsForm.vue?vue&type=script&lang=js"
export * from "./ExportQuestionsForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__